import api from 'features/common/transport'
import {ERROR_DEFAULT} from 'features/common/core/errors'
import {Employee} from '../../../../core/entities/employee'

const updateEmployee = async (employee: Employee) => {
    const {
        id,
        firstName,
        lastName,
        phone,
        email,
        birth,
        role,
        qrId,
        organizationId,
        avatar,
    } = employee
    const res = await api.put(`team/member/${employee.id}`, {
        body: JSON.stringify({
            id,
            first_name: firstName,
            last_name: lastName,
            birth,
            phone,
            email,
            role,
            qr_id: qrId,
            organization_id: organizationId,
            avatar,
        }),
    })

    if (!res.ok) {
        throw new Error(ERROR_DEFAULT + ' ' + res.statusText)
    }
}
export default updateEmployee
